<template>
    <div class="about-hero-wrap">
        <div class="hero-header">
            <h3 class="title-with-dot">{{ aboutData.title }}</h3>
            <router-link to="/contact" class="status-for-work">{{ aboutData.status }}</router-link>
        </div>

        <div class="about-hero-content-body">
            <div class="about-hero-content">
                <h1>{{ aboutData.name }}</h1>
                <p>{{ aboutData.description }}</p>
                <div class="buttons">
                    <router-link to="/contact" class="theme-btn">
                        <span class="btn-shape"></span>
                        <span class="btn-shape"></span>
                        <span class="btn-shape"></span>
                        <span class="plus-icon">+</span> {{ aboutData.btnText }}
                    </router-link>
                    
                    <copy-button />
                </div>
            </div>
            <div class="about-hero-img">
                <img :src="aboutData.img" alt="About"/>
            </div>
        </div>
    </div>
</template>

<script>
import CopyButton from '../modules/CopyButton.vue';

export default {
    name: 'HeroSection',
    components: {
        CopyButton
    },
    data() {
        return {
            aboutData: {
                img: require('@/assets/images/me.png'),
                title: 'Product Designer',
                status: 'Available for work',
                name: "I'm Tanbir Do",
                description: 'Product designer from Jakarta, ID. Currently designing at Rectangle.',
                btnText: 'Hire Me'
            }
        }
    }
}
</script>